import team1 from "./img/Mehedi.png";
import team2 from "./img/Jarif-Huda-Angon.png";
import team3 from "./img/asaf-kakon.jpg";
import team4 from "./img/ishtiuq.png";
import team5 from "./img/Sabbir.jpg";
import team6 from "./img/Nasim.png";
import team7 from "./img/Biswajit.png";
import team8 from "./img/Shahajalal.png";

const TeamCardData = [
  {
    id: "1",
    name: "Mehedi Hassan",
    slug: "ceo",
    img: team1,
    designation: "Chairman & Cheif Executive Officer",
    content_1:
      "The Virtual BD District has been providing dependable information technology and research services. My objective is to continue along this path into the foreseeable future and establish The Virtual BD as a preeminent enterprise operating on a worldwide scale.",

    content_2:
      "The rate of change is unparalleled, as is the scope of it, and we continue to encounter new challenges in the context of our technology.",
    content_3:
      "The Virtual BD has undergone an organizational change that involves efforts such as digitalization and innovation in order to solve these obstacles. This transformation was necessary in order for them to be successful. Because of these enhancements, we will be able to become more efficient in recognizing and responding to shifts among young people. However, there is still more work to be done, and we are unwavering in our dedication to further enhancing our capabilities and developing the company in the years to come.",
    facebook: "https://www.facebook.com/MhashiqCEO",
    twitter: "https://twitter.com/home",
    instagram: "https://www.instagram.com/accounts/login/?next=/mh_ashiq_/",
  },
  {
    id: "2",
    img: team2,
    name: "Jarif Huda Angon",
    slug: "cto",
    designation: "Co-Founder & CTO",
    content_1:
      "Building your ideal stuff isn't as easy as you think since unless you transform your ideas and thoughts into reality.you have to confront with many failure attempts and without failing you can't win. You can't build a revolution if you are hungry. Therefore make some money to keep your stomach full.",

    content_2: "",
    content_3: "",
    facebook: "https://www.facebook.com/Angon.zarif",
    twitter: "https://twitter.com/home",
    instagram: "https://instagram.com/angon_zarif?igshid=YmMyMTA2M2Y=",
  },
  {
    id: "3",
    img: team3,
    name: "Asaf Ud Dulla",
    slug: "cmo",
    designation: "Co-Founder & CMO",
    content_1:
      "The Virtual BD District has been providing dependable information technology and research services. My objective is to continue along this path into the foreseeable future and establish The Virtual BD as a preeminent enterprise operating on a worldwide scale.",

    facebook: "https://www.facebook.com/KakonCMO",
    twitter: "https://twitter.com/home",
    instagram:
      "https://www.instagram.com/invites/contact/?i=1ncexy37anvtz&utm_content=419g8qc",
  },

  {
    id: "4",
    img: team4,
    name: "Ishtiuq Ahmed Chowdhury",
    slug: "ishtiuq",
    designation: "Graphic & UI/UX Designer",
    content_1:
      "The Virtual BD District has been providing dependable information technology and research services. My objective is to continue along this path into the foreseeable future and establish The Virtual BD as a preeminent enterprise operating on a worldwide scale.",

    content_2:
      "The rate of change is unparalleled, as is the scope of it, and we continue to encounter new challenges in the context of our technology.",
    content_3:
      "The Virtual BD has undergone an organizational change that involves efforts such as digitalization and innovation in order to solve these obstacles. This transformation was necessary in order for them to be successful. Because of these enhancements, we will be able to become more efficient in recognizing and responding to shifts among young people. However, there is still more work to be done, and we are unwavering in our dedication to further enhancing our capabilities and developing the company in the years to come.",
    facebook: "https://www.facebook.com/",
    twitter: "https://twitter.com/",
    instagram: "https://www.instagram.com/",
    github: "https://github.com/chowdhuryishtiuq",
  },
  {
    id: "5",
    img: team5,
    name: "Sabbir Hussain",
    slug: "sabbir",
    designation: "Sr. Web Developer",
    content_1:
      "The Virtual  Bangladesh District has been providing dependable information technology and research services. My objective is to continue along this path into the foreseeable future and establish The Virtual BD as a preeminent enterprise operating on a worldwide scale.",

    content_2:
      "The rate of change is unparalleled, as is the scope of it, and we continue to encounter new challenges in the context of our technology.",
    content_3:
      "The Virtual BD has undergone an organizational change that involves efforts such as digitalization and innovation in order to solve these obstacles. This transformation was necessary in order for them to be successful. Because of these enhancements, we will be able to become more efficient in recognizing and responding to shifts among young people. However, there is still more work to be done, and we are unwavering in our dedication to further enhancing our capabilities and developing the company in the years to come.",
    facebook: "https://www.facebook.com/",
    twitter: "https://twitter.com/",
    instagram: "https://www.instagram.com/",
    github: "https://github.com/Hussains3",
  },
  {
    id: "6",
    img: team7,
    name: "Biswajit Sikdar",
    slug: "sikdar",
    designation: "Front-End Developer",
    content_1:
      "The Virtual BD District has been providing dependable information technology and research services. My objective is to continue along this path into the foreseeable future and establish The Virtual BD as a preeminent enterprise operating on a worldwide scale.",

    content_2:
      "The rate of change is unparalleled, as is the scope of it, and we continue to encounter new challenges in the context of our technology.",
    content_3:
      "The Virtual BD has undergone an organizational change that involves efforts such as digitalization and innovation in order to solve these obstacles. This transformation was necessary in order for them to be successful. Because of these enhancements, we will be able to become more efficient in recognizing and responding to shifts among young people. However, there is still more work to be done, and we are unwavering in our dedication to further enhancing our capabilities and developing the company in the years to come.",
    facebook: "https://www.facebook.com/",
    twitter: "https://twitter.com/",
    instagram: "https://www.instagram.com/",
    github: "https://github.com/webdevbiswaajit",
  },
  {
    id: "7",
    img: team6,
    name: "Md Nasim Uddin",
    slug: "nasim",
    designation: "Digital Marketer",
    content_1:
      "The Virtual BD District has been providing dependable information technology and research services. My objective is to continue along this path into the foreseeable future and establish The Virtual BD as a preeminent enterprise operating on a worldwide scale.",

    content_2:
      "The rate of change is unparalleled, as is the scope of it, and we continue to encounter new challenges in the context of our technology.",
    content_3:
      "The Virtual BD has undergone an organizational change that involves efforts such as digitalization and innovation in order to solve these obstacles. This transformation was necessary in order for them to be successful. Because of these enhancements, we will be able to become more efficient in recognizing and responding to shifts among young people. However, there is still more work to be done, and we are unwavering in our dedication to further enhancing our capabilities and developing the company in the years to come.",
    facebook: "https://www.facebook.com/",
    twitter: "https://twitter.com/",
    instagram: "https://www.instagram.com/",
  },
  {
    id: "8",
    img: team8,
    name: "Shahajalal",
    slug: "shahajalal",
    designation: "Assistant Accountant",
    content_1:
      "The Virtual BD District has been providing dependable information technology and research services. My objective is to continue along this path into the foreseeable future and establish The Virtual BD as a preeminent enterprise operating on a worldwide scale.",

    content_2:
      "The rate of change is unparalleled, as is the scope of it, and we continue to encounter new challenges in the context of our technology.",
    content_3:
      "The Virtual BD has undergone an organizational change that involves efforts such as digitalization and innovation in order to solve these obstacles. This transformation was necessary in order for them to be successful. Because of these enhancements, we will be able to become more efficient in recognizing and responding to shifts among young people. However, there is still more work to be done, and we are unwavering in our dedication to further enhancing our capabilities and developing the company in the years to come.",
    facebook: "https://www.facebook.com/",
    twitter: "https://twitter.com/",
    instagram: "https://www.instagram.com/",
  },
];
export default TeamCardData;
